export enum ToolTipTexts {
    ROLE = 'Para adicionar un nuevo cargo seleccioné la opción Adicionar cargo.',
    DEPARTMENT = 'Para adicionar una nueva área seleccioné la opción Adicionar área.',
    PERMANENT_SALARY_CHANGE = 'Al seleccionar esta opción, ten en cuenta que el cambio se efectúa a partir de la fecha registrada, los meses anteriores conservarán el salario previamente almacenado.',
    SALARY = 'Recuerda que el SMMLV del año en curso es de {minimum_salary}.',
}
